<template>
    <div class="image-shooter-gallery mt-4">
        <v-layout row wrap>
            <v-flex xs12 sm4 lg3 v-for="i in quantity" :key="i">
                <a data-fancybox="gallery" data-type="image" :href="`/img/${directory}/${i}.jpg`" width="100%">
                    <div class="thumb">
                        <img :src="`/img/${directory}/${i}th.jpg`" alt="Oksana Kowcz">              
                    </div>     
                </a>       
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: 'ImageShooterGallery',
        props: ['directory', 'quantity']
    }
</script>

